<template>
    <van-tabs type="card" color="#07C160" sticky :offset-top="100">
        <van-tab style="margin-top: 10px" title="合同信息">
            <van-cell-group>
                <van-field required clearable v-model="contractNo" :error-message="contractNoErr" label="借款合同号"
                    placeholder="请输入借款合同号" :readonly="read" />

                <van-field label="抵押合同号" v-model="mortgageContractNo" :error-message="mortgageContractNoErr" clearable
                    :readonly="read" placeholder="请输入抵押合同号(房抵贷必填)" />
            </van-cell-group>

            <van-row v-if="!read">
                <van-col offset="10" style="margin-top: 10px;">
                    <van-button type="primary" size="small" @click="saveContractNo">保存合同号</van-button>
                </van-col>
            </van-row>
        </van-tab>

        <van-tab title="合同附件">
            <van-collapse v-model="actives">
                <van-collapse-item v-for="item in contractItems" :key="item.name" :title="item.title" :name="item.name">
                    <oss-upload :isUpload="parseInt(auditStatus) === 7" :applyId="applyId" :groupCode="item.groupCode"
                        :refName="item.refName" />
                </van-collapse-item>
            </van-collapse>
        </van-tab>

<!--        <van-tab title="展期合同">-->
<!--            <div style="padding: 20px 0 10px 20px;font-weight: bold">预签署展期合同</div>-->
<!--            <van-radio-group v-model="preSignContract" @change="preSelect" :disabled="disabledRadio">-->
<!--                <van-cell-group>-->
<!--                    <van-cell title="是" clickable>-->
<!--                        <van-radio name="yes" />-->
<!--                    </van-cell>-->
<!--                    <van-cell title="否" clickable>-->
<!--                        <van-radio name="no" />-->
<!--                    </van-cell>-->
<!--                </van-cell-group>-->
<!--            </van-radio-group>-->

<!--            <div style="padding: 20px 0 10px 20px;font-weight: bold">展期合同附件上传</div>-->
<!--            <van-collapse v-model="actives">-->
<!--                <van-collapse-item v-for="item in extItems" :key="item.name" :title="item.title" :name="item.name">-->
<!--                    <oss-upload :isUpload="parseInt(auditStatus) === 7" :applyId="applyId" :groupCode="item.groupCode"-->
<!--                        :refName="item.refName" />-->
<!--                </van-collapse-item>-->
<!--            </van-collapse>-->

<!--        </van-tab>-->

        <van-tab style="margin-top: 10px" title="还款计划">
            <van-row>
                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" error-text="请求失败，点击重新加载"
                    @load="onLoad">
                    <van-cell>
                        <van-row style="text-align: center">
                            <van-col span="2">
                                序
                            </van-col>
                            <van-col span="6">
                                本金
                            </van-col>
                            <van-col span="6">
                                利息
                            </van-col>
                            <van-col span="4">
                                状态
                            </van-col>

                            <van-col span="6">
                                预期还款
                            </van-col>
                        </van-row>
                    </van-cell>
                    <van-cell style="padding: 20px" v-for="(item, index) in list" :key="index" center>
                        <template>
                            <van-row style="text-align: center">
                                <van-col span="2">
                                    {{ item.periodNo }}
                                </van-col>
                                <van-col span="6">
                                    {{ item.principalAmount }}
                                </van-col>
                                <van-col span="6">
                                    {{ item.interestAmount }}
                                </van-col>
                                <van-col span="4">
                                    {{ item.statusCn }}
                                </van-col>

                                <van-col span="6">
                                    {{ item.requiredRepayDate | dateYmdFormat }}
                                </van-col>
                            </van-row>
                        </template>
                    </van-cell>
                </van-list>
            </van-row>
        </van-tab>

        <!-- 到期日 -->
        <van-dialog v-if="auditStatus == '7'" v-model="expirationDateShow" :title="auditTitle" show-cancel-button
            :before-close="confirmExpirationDate" @cancel="expirationDateShow = false">
            <van-field style="margin: 10px 0" type="text" label="到期日期" right-icon="clock" readonly placeholder="点击选择日期"
                @click="showDatePicker = true" :error-message="expirationDateErr"
                @click-right-icon="showDatePicker = true" clearable v-model="expirationDate" />

        </van-dialog>

        <van-popup v-model="showDatePicker" position="bottom">
            <van-datetime-picker type="date" @confirm="confirmDate" :min-date="new Date()"
                @cancel="showDatePicker = false" />
        </van-popup>

        <!-- 审核通过 -->
        <van-dialog v-if="auditStatus == '7'" v-model="auditPassShow" :title="auditTitle" show-cancel-button
            :before-close="auditPass" @cancel="auditPassShow = false">
            <van-field style="margin: 10px 0" type="text" label="借款合同号" readonly v-model="contractNo" />

            <van-field style="margin: 10px 0" type="text" label="抵押合同号" readonly v-model="mortgageContractNo" />
            <van-field style="margin: 10px 0" type="textarea" label="审批意见" clearable :error-message="remarkErr"
                placeholder="请输入审批意见" v-model="remark" />

        </van-dialog>
    </van-tabs>
</template>

<script>
import { updateContractNo, savePreSignContract, saveExpirationDate, mortgageRepayPlan, auditProcess } from '@/api/loanInfo'
import { mapGetters } from 'vuex'
import {eventBus} from '@/vue/utils/eventBus'
import Attachment from '../attachment.vue'
import FilesUpload from '@/views/home/business/mortgage/files-upload.vue'
import ossUpload from '@/views/component/oss-upload'
export default {
    name: 'mortgage_contract',
    components: {
        Attachment,
        FilesUpload,
        ossUpload
    },
    props: {
        applyId: {
            type: String,
            default: ''
        }
    },
    watch: {
        'contractNo'(val) {
            if (val == undefined || val.length > 0) {
                this.contractNoErr = ''
            }
        },
        'mortgageContractNo'(val) {
            if (val == undefined || val.length > 0) {
                this.mortgageContractNoErr = ''
            }
        },
        'expirationDateErr'(val) {
            if (val == undefined || val.length > 0) {
                this.expirationDateErr = ''
            }
        },
        'remarkErr'(val) {
            if (val == undefined || val.length > 0) {
                this.remarkErr = ''
            }
        }
    },
    computed: mapGetters([
        'auditStatus',
        'applyInfo'
    ]),
    data() {
        return {
            preSignContract: 'no',
            actives: [],
            contractNo: '',
            contractNoErr: '',
            mortgageContractNo: '',
            mortgageContractNoErr: '',
            remark: '',
            remarkErr: '',
            expirationDate: '',
            expirationDateErr: '',
            expirationDateShow: false,
            showDatePicker: false,
            disabledRadio: true,
            read: true,
            auditTitle: '',
            currentDate: new Date(),
            //还款计划相关
            loading: false,
            finished: false,
            auditPassShow: false,
            list: [],
            contractItems: [
                { title: '合同文书', name: '1', groupCode: 67, refName: 'htws' },
                { title: '贷款申请表', name: '2', groupCode: 207, refName: 'dksqb' },
                { title: '抵押合同', name: '3', groupCode: 208, refName: 'dyht' },
                { title: '扣款授权书', name: '4', groupCode: 209, refName: 'kksqs' },
                { title: '签约照片', name: '5', groupCode: 210, refName: 'kksqs' },
                { title: '入押回执', name: '6', groupCode: 211, refName: 'kksqs' },
                { title: '房屋查册【北京通】', name: '7', groupCode: 212, refName: 'kksqs' },
                { title: '征信授权书', name: '8', groupCode: 103, refName: 'kksqs' },
                { title: '经营相关（经营资料确认书|无经营场所情况说明）', name: '9', groupCode: 20, refName: 'kksqs' }
            ],
            extItems: [
                { title: '展期合同', name: '1', groupCode: 202, refName: 'zqht' },
                { title: '收费明细表', name: '2', groupCode: 203, refName: 'sfmxb' },
                { title: '债转通知书', name: '3', groupCode: 204, refName: 'zztzs' },
                { title: '委托还款确认书', name: '4', groupCode: 213, refName: 'other' },
                { title: '其他资料', name: '5', groupCode: 205, refName: 'other' }
            ]

        }
    },
    mounted() {

        let self = this

        this.initData()
        setTimeout(function () {
            if (self.auditStatus == '7') {
                self.read = false
                self.disabledRadio = false
            }
        }, 600)

        //初始化审批事件
        eventBus.$on('contractGatherAudit', function (status) {
            //审批操作
            self.audit(status)
        })
    },
    destroyed() {
        eventBus.$off('contractGatherAudit')
    },
    methods: {
        onLoad() {
            //激活还款计划tab
            let params = {
                applyId: this.applyId
            }
            mortgageRepayPlan(params).then(res => {
                if (res.success) {
                    this.list = res.data
                    this.$toast('获取还款计划成功')
                } else {
                    this.$toast('获取还款计划失败')
                }
                // 加载状态结束
                this.loading = false
                this.finished = true
            })
        },
        confirmDate(value) {
            this.showDatePicker = false
            this.expirationDate = value.toLocaleString()
        },
        initData() {
            this.contractNo = this.applyInfo.contractNo
            this.mortgageContractNo = this.applyInfo.mortgageContractNo
            this.preSignContract = this.applyInfo.preSignContract
        },
        preSelect(name) {
            this.preSignContract = name
            let params = {
                applyId: this.applyId,
                preSignContract: this.preSignContract,
            }
            savePreSignContract(params).then(res => {
                this.$toast(res.msg)
            })
        },
        confirmExpirationDate(action, done) {
            if (action === 'confirm') {
                if (!this.expirationDate) {
                    this.expirationDateErr = '请选择到期时间'
                    done(false)
                    return false
                }
                let params = {
                    applyId: this.applyId,
                    expirationDate: this.expirationDate
                }
                saveExpirationDate(params).then(res => {
                    this.$toast(res.msg)
                    done()
                })
            }
        },
        //审批操作
        audit(status) {
            console.log('audd')
            if (status == '1') {//修改到期日期
                this.expirationDateShow = true
                this.auditTitle = '修改到期日期'
            } else if (status == '2') {//生成还款计划
                this.onLoad()
            } else if (status == '3') {//审核通过
                this.auditTitle = '审核通过'
                this.auditPassShow = true
            } else if (status == '4') {//挂单

            } else if (status == '5') {//拒单

            } else if (status == '6') {//客户放弃

            }
        },
        //审批通过
        auditPass(action, done) {
            if (!this.remark) {
                this.remarkErr = '请填写审批意见'
                this.$toast('请填写审批意见')
                done(false)
                return false
            }
            let params = {
                applyId: this.applyId,
                remark: this.remark,
                contractNo: this.contractNo,
                process: 'CONTRACT_GATHER',
                type: 'pass'
            }

            auditProcess(params).then(res => {
                if (res.success) {
                    this.$router.go(-1)
                }
                done()
                this.$toast(res.msg)
            })
        },
        saveContractNo() {
            //验证
            if (!this.contractNo) {
                this.contractNoErr = '请输入借款合同号'
                return false
            }
            if (this.applyInfo.productFlag == '1100080' && !this.mortgageContractNo) {
                this.mortgageContractNoErr = '请输入抵押合同号'
                return false
            }

            let params = {
              applyId: this.applyId,
              contractNo: this.contractNo,
              mortgageContractNo: this.mortgageContractNo
            }

            updateContractNo(params).then(res => {
                this.$toast(res.msg)
            })
        }
    }
}
</script>

<style scoped>
.uploadIcon {
    height: 80px;
    width: 80px;
    margin: 0 auto;
    line-height: 80px;
    border: 1px dashed #afb1b3;
}
</style>
